import Actions from 'actions';

const initialState = Object.freeze({});

function fetch(state = initialState, action) {
  switch (action.type) {
    case Actions.FETCH_USER_CREDIT_CARD_REQUEST:
      return initialState;
    case Actions.FETCH_USER_CREDIT_CARD_SUCCESS:
      return {
        ...initialState,
        data: action.data,
      };
    case Actions.FETCH_USER_CREDIT_CARD_FAIL:
      return {
        ...initialState,
        error: action.error,
      };
    default:
      return state;
  }
}

export default fetch;
